var _path, _mask, _path2, _mask2, _path3, _mask3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _mask4, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _mask5, _path40, _mask6, _path41, _path42, _mask7, _path43, _path44, _mask8, _path45, _path46, _path47, _path48, _path49, _mask9, _path50, _path51, _path52, _mask10, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _mask11, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _mask12, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _g, _mask13, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckRightDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 395,
    viewBox: "0 0 422 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3321 192.292V196.22L94.5472 175.493V171.586L115.26 159.736L118.365 161.711L115.26 177.099L40.7239 223.48L37.6191 221.505V204.142L58.3321 192.292Z",
    fill: "#000F20"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4158 194.288V198.195L97.6527 177.468V173.562L118.366 161.711V179.074L40.7246 223.48V206.117L61.4158 194.288Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4158 194.288V198.195L97.6527 177.468V173.562L118.366 161.711V179.074L40.7246 223.48V206.117L61.4158 194.288Z",
    fill: "url(#paint0_linear_3124_28296)",
    stroke: "#222222",
    strokeWidth: 2,
    mask: "url(#path-2-inside-1_3124_28296)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.735 282.34L206.458 275.069L254.701 302.568L240.545 322.383L234.662 338.465L186.396 310.88L186.44 294.863C186.44 289.698 189.219 284.923 193.713 282.34H193.735Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.735 282.34L206.458 275.069L254.701 302.568L240.545 322.383L234.662 338.465L186.396 310.88L186.44 294.863C186.44 289.698 189.219 284.923 193.713 282.34H193.735Z",
    fill: "#222222",
    stroke: "url(#paint1_linear_3124_28296)",
    strokeWidth: 2,
    mask: "url(#path-3-inside-2_3124_28296)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.684 338.444L254.723 326.984V302.568L244.519 308.406C238.44 311.879 234.684 318.346 234.684 325.357V338.444Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M234.684 338.444L254.723 326.984V302.568L244.519 308.406C238.44 311.879 234.684 318.346 234.684 325.357V338.444Z",
    fill: "#222222",
    stroke: "url(#paint2_linear_3124_28296)",
    strokeWidth: 2,
    mask: "url(#path-4-inside-3_3124_28296)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4483 217.273C58.4483 217.273 50.6321 220.506 50.3281 232.27L55.6475 229.47L63.4637 223.219L69.0002 219.899L71.4536 216.665C68.6528 211.977 58.4483 217.273 58.4483 217.273Z",
    fill: "url(#paint3_linear_3124_28296)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7934 219.53L74.6238 211.543C75.3185 211.001 76.0785 210.566 76.8601 210.241H76.8818C79.9866 208.96 83.7861 209.308 87.8896 211.587C98.3764 217.425 106.887 233.659 106.887 247.853C106.887 255.905 104.152 261.57 99.8745 263.914H99.8962L83.569 273.268L83.8512 269.817L86.9343 262.894C86.9343 262.894 87.0429 262.785 87.2165 262.612C77.0121 256.491 68.8702 240.626 68.8702 226.714C68.8702 225.195 68.9787 223.741 69.1524 222.395H66.8944L60.75 219.508L60.7934 219.53Z",
    fill: "#000F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4336 236.177C52.4336 250.371 60.9446 266.627 71.4313 272.443C81.9181 278.282 90.4291 271.488 90.4291 257.294C90.4291 243.1 81.9181 226.844 71.4313 221.028C60.9446 215.189 52.4336 221.983 52.4336 236.177Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3184 239.454C58.3184 249.264 64.2022 260.485 71.4322 264.5C78.6839 268.537 84.5461 263.849 84.5461 254.039C84.5461 244.229 78.6622 233.008 71.4322 228.993C64.1805 224.956 58.3184 229.644 58.3184 239.454Z",
    fill: "url(#paint4_linear_3124_28296)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7715 240.821C60.7715 248.786 65.5481 257.902 71.4319 261.179C77.3158 264.456 82.0924 260.637 82.0924 252.671C82.0924 244.706 77.3158 235.591 71.4319 232.313C65.5481 229.036 60.7715 232.856 60.7715 240.821Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.334 241.689C62.334 248.504 66.4158 256.274 71.4529 259.074C76.49 261.874 80.5718 258.618 80.5718 251.803C80.5718 244.988 76.49 237.218 71.4529 234.419C66.4158 231.619 62.334 234.874 62.334 241.689Z",
    fill: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63 242.261C63 248.23 66.5824 255.067 70.9899 257.519C75.3974 259.972 78.9798 257.128 78.9798 251.138C78.9798 245.148 75.3974 238.333 70.9899 235.881C66.5824 233.428 63 236.271 63 242.261Z",
    fill: "#222222"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1309 244.901C68.1309 247.376 69.6073 250.197 71.431 251.217C73.2548 252.237 74.7312 251.043 74.7312 248.569C74.7312 246.095 73.2548 243.274 71.431 242.254C69.6073 241.233 68.1309 242.427 68.1309 244.901Z",
    fill: "#D7F0FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3281 245.488C67.3281 247.832 68.7394 250.523 70.4763 251.478C72.2133 252.433 73.6245 251.326 73.6245 248.982C73.6245 246.638 72.2133 243.947 70.4763 242.992C68.7394 242.037 67.3281 243.144 67.3281 245.488Z",
    fill: "url(#paint5_linear_3124_28296)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8964 237.761C64.7662 237.696 64.6576 237.609 64.5273 237.5C65.0267 236.611 65.6781 235.938 66.4597 235.525C66.5248 235.808 66.5682 236.111 66.5682 236.394C66.5682 237.652 65.8083 238.26 64.8747 237.739L64.8964 237.761Z",
    fill: "url(#paint6_linear_3124_28296)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5046 249.394C66.4382 249.915 67.1981 251.369 67.1981 252.628C67.1981 252.91 67.1547 253.17 67.0896 253.366C66.2211 252.107 65.4612 250.696 64.875 249.199C65.0704 249.199 65.2875 249.264 65.5263 249.372L65.5046 249.394Z",
    fill: "url(#paint7_linear_3124_28296)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4524 235.938C71.9952 236.242 72.538 236.611 73.059 237.045C72.8419 237.848 72.2123 238.173 71.4524 237.761C70.6925 237.349 70.0628 236.307 69.8457 235.265C70.3668 235.417 70.9096 235.634 71.4524 235.938Z",
    fill: "url(#paint8_linear_3124_28296)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8959 242.319C64.8959 243.425 64.3096 244.033 63.5497 243.816C63.5063 243.317 63.4629 242.796 63.4629 242.297C63.4629 241.277 63.5714 240.365 63.7669 239.541C64.4182 240.213 64.8959 241.32 64.8959 242.319Z",
    fill: "url(#paint9_linear_3124_28296)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9478 258.184C75.7958 257.772 75.709 257.316 75.709 256.903C75.709 255.645 76.4689 255.037 77.4025 255.558C77.6848 255.71 77.967 255.97 78.1841 256.274C77.5979 257.207 76.838 257.858 75.9261 258.206L75.9478 258.184Z",
    fill: "url(#paint10_linear_3124_28296)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4528 255.536C72.2562 255.992 72.9292 257.121 73.1029 258.249C72.5601 258.097 72.0173 257.88 71.4528 257.555C70.8883 257.229 70.3238 256.86 69.8027 256.404C69.9764 255.471 70.6495 255.08 71.4528 255.536Z",
    fill: "url(#paint11_linear_3124_28296)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0312 250.11C78.0312 249.069 78.5306 248.504 79.2254 248.591C79.3557 249.459 79.4425 250.328 79.4425 251.174C79.4425 251.825 79.3991 252.454 79.3122 253.04C78.574 252.389 78.0312 251.174 78.0312 250.11Z",
    fill: "url(#paint12_linear_3124_28296)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.424 244.315C76.4904 243.794 75.7305 242.34 75.7305 241.082C75.7305 240.734 75.7956 240.452 75.8824 240.213C76.7726 241.516 77.5325 242.97 78.1188 244.511C77.9016 244.511 77.6628 244.467 77.424 244.337V244.315Z",
    fill: "url(#paint13_linear_3124_28296)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-4_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.948 248.222L93.3616 256.166C93.3616 256.166 92.9057 225.759 70.4558 217.273C70.4558 217.273 64.1594 214.885 58.4492 217.273L68.6971 212.693L108.625 235.526C108.625 235.526 111.404 240.213 110.948 248.222Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110.948 248.222L93.3616 256.166C93.3616 256.166 92.9057 225.759 70.4558 217.273C70.4558 217.273 64.1594 214.885 58.4492 217.273L68.6971 212.693L108.625 235.526C108.625 235.526 111.404 240.213 110.948 248.222Z",
    fill: "#222222",
    stroke: "url(#paint14_linear_3124_28296)",
    strokeWidth: 2,
    mask: "url(#path-22-inside-4_3124_28296)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105.997 244.576C105.997 244.576 98.1809 247.81 97.877 259.573L103.196 256.773L111.013 250.523L116.549 247.202L119.002 243.968C116.202 239.28 105.997 244.576 105.997 244.576Z",
    fill: "url(#paint15_linear_3124_28296)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.342 246.833L122.173 238.846C122.867 238.303 123.627 237.869 124.409 237.544H124.431C127.535 236.263 131.335 236.61 135.438 238.889C145.925 244.727 154.436 260.962 154.436 275.156C154.436 283.208 151.7 288.873 147.423 291.217H147.445L131.118 300.571L131.4 297.12L134.483 290.196C134.483 290.196 134.592 290.088 134.765 289.914C124.561 283.794 116.419 267.929 116.419 254.017C116.419 252.497 116.528 251.043 116.701 249.698H114.443L108.299 246.811L108.342 246.833Z",
    fill: "#000F20"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.995 301.119C138.548 297.644 140.552 282.701 134.47 267.744C128.388 252.786 116.523 243.478 107.97 246.953C99.4164 250.429 97.4128 265.372 103.495 280.329C109.577 295.287 121.441 304.595 129.995 301.119Z",
    fill: "#222222"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M105.867 266.757C105.867 276.567 111.751 287.788 118.981 291.803C126.233 295.84 132.095 291.152 132.095 281.342C132.095 271.532 126.211 260.311 118.981 256.296C111.729 252.259 105.867 256.947 105.867 266.757Z",
    fill: "url(#paint16_linear_3124_28296)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.32 268.124C108.32 276.089 113.097 285.205 118.981 288.482C124.865 291.759 129.641 287.939 129.641 279.974C129.641 272.009 124.865 262.893 118.981 259.616C113.097 256.339 108.32 260.159 108.32 268.124Z",
    fill: "#000F20"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M109.883 268.992C109.883 275.807 113.965 283.577 119.002 286.377C124.039 289.176 128.121 285.921 128.121 279.106C128.121 272.291 124.039 264.521 119.002 261.721C113.965 258.922 109.883 262.177 109.883 268.992Z",
    fill: "#222222"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M123.618 285.437C127.217 283.974 128.059 277.685 125.499 271.389C122.939 265.092 117.946 261.174 114.347 262.636C110.748 264.099 109.905 270.388 112.466 276.684C115.026 282.98 120.019 286.899 123.618 285.437Z",
    fill: "#222222"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M115.68 272.204C115.68 274.678 117.156 277.5 118.98 278.52C120.804 279.54 122.28 278.346 122.28 275.872C122.28 273.398 120.804 270.576 118.98 269.556C117.156 268.536 115.68 269.73 115.68 272.204Z",
    fill: "#D7F0FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M114.855 272.79C114.855 275.134 116.267 277.826 118.004 278.781C119.741 279.735 121.152 278.629 121.152 276.285C121.152 273.941 119.741 271.249 118.004 270.294C116.267 269.339 114.855 270.446 114.855 272.79Z",
    fill: "url(#paint17_linear_3124_28296)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M112.424 265.064C112.294 264.998 112.185 264.912 112.055 264.803C112.554 263.913 113.205 263.24 113.987 262.828C114.052 263.11 114.096 263.414 114.096 263.696C114.096 264.955 113.336 265.563 112.402 265.042L112.424 265.064Z",
    fill: "url(#paint18_linear_3124_28296)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M113.032 276.697C113.966 277.218 114.725 278.672 114.725 279.931C114.725 280.213 114.682 280.473 114.617 280.669C113.748 279.41 112.989 277.999 112.402 276.501C112.598 276.501 112.815 276.567 113.054 276.675L113.032 276.697Z",
    fill: "url(#paint19_linear_3124_28296)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M118.98 263.241C119.522 263.545 120.065 263.913 120.586 264.348C120.369 265.151 119.74 265.476 118.98 265.064C118.22 264.651 117.59 263.61 117.373 262.568C117.894 262.72 118.437 262.937 118.98 263.241Z",
    fill: "url(#paint20_linear_3124_28296)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M112.423 269.621C112.423 270.728 111.837 271.336 111.077 271.119C111.034 270.62 110.99 270.099 110.99 269.6C110.99 268.58 111.099 267.668 111.294 266.843C111.946 267.516 112.423 268.623 112.423 269.621Z",
    fill: "url(#paint21_linear_3124_28296)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M123.497 285.487C123.345 285.074 123.258 284.618 123.258 284.206C123.258 282.947 124.018 282.34 124.951 282.86C125.234 283.012 125.516 283.273 125.733 283.577C125.147 284.51 124.387 285.161 123.475 285.508L123.497 285.487Z",
    fill: "url(#paint22_linear_3124_28296)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M118.98 282.839C119.783 283.295 120.457 284.423 120.63 285.552C120.087 285.4 119.545 285.183 118.98 284.857C118.416 284.532 117.851 284.163 117.33 283.707C117.504 282.774 118.177 282.383 118.98 282.839Z",
    fill: "url(#paint23_linear_3124_28296)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M125.559 277.413C125.559 276.371 126.058 275.807 126.753 275.894C126.883 276.762 126.97 277.63 126.97 278.477C126.97 279.128 126.926 279.757 126.84 280.343C126.101 279.692 125.559 278.477 125.559 277.413Z",
    fill: "url(#paint24_linear_3124_28296)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M124.951 271.618C124.018 271.097 123.258 269.643 123.258 268.384C123.258 268.037 123.323 267.755 123.41 267.516C124.3 268.818 125.06 270.272 125.646 271.813C125.429 271.813 125.19 271.77 124.951 271.64V271.618Z",
    fill: "url(#paint25_linear_3124_28296)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-40-inside-5_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.497 275.525L140.91 283.468C140.91 283.468 140.454 253.062 118.005 244.576C118.005 244.576 111.708 242.188 105.998 244.576L116.246 239.996L156.174 262.828C156.174 262.828 158.953 267.516 158.497 275.525Z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M158.497 275.525L140.91 283.468C140.91 283.468 140.454 253.062 118.005 244.576C118.005 244.576 111.708 242.188 105.998 244.576L116.246 239.996L156.174 262.828C156.174 262.828 158.953 267.516 158.497 275.525Z",
    fill: "#222222",
    stroke: "url(#paint26_linear_3124_28296)",
    strokeWidth: 2,
    mask: "url(#path-40-inside-5_3124_28296)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-41-inside-6_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 175.348L236.006 310.235V190.888L0 56V175.348Z"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 175.348L236.006 310.235V190.888L0 56V175.348Z",
    fill: "#222222",
    stroke: "url(#paint27_linear_3124_28296)",
    strokeWidth: 12,
    mask: "url(#path-41-inside-6_3124_28296)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16864 62.9622L231.837 193.097V302.852L4.16864 172.717V62.9622ZM0 55.7783V175.126L236.006 310.014V190.666L0 55.7783Z",
    fill: "#222222"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-7_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.984 190.557L333.991 134.497L98.0066 0L0 56.0386L235.984 190.557Z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M235.984 190.557L333.991 134.497L98.0066 0L0 56.0386L235.984 190.557Z",
    fill: "#222222",
    stroke: "url(#paint28_linear_3124_28296)",
    strokeWidth: 12,
    mask: "url(#path-43-inside-7_3124_28296)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0498 4.79649L325.632 134.519L236.006 185.761L8.42391 56.0386L98.0498 4.79649ZM98.0498 0L0.0214844 56.0386L235.984 190.536L333.991 134.497L98.028 0H98.0498Z",
    fill: "#222222"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-8_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.006 309.992L334.012 253.932V134.497L236.006 190.557V309.992Z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M236.006 309.992L334.012 253.932V134.497L236.006 190.557V309.992Z",
    fill: "#222222",
    stroke: "url(#paint29_linear_3124_28296)",
    strokeWidth: 12,
    mask: "url(#path-45-inside-8_3124_28296)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M329.844 141.681V251.523L240.153 302.83V192.988L329.844 141.681ZM334.012 134.497L236.006 190.557V309.992L334.012 253.932V134.497Z",
    fill: "#222222"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M392.439 269.86L395.067 271.553V233.268L392.439 231.575V269.86Z",
    fill: "#222222"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M395.067 233.246L409.961 224.912L407.312 223.306L392.439 231.64L395.067 233.246Z",
    fill: "url(#paint30_linear_3124_28296)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M395.066 271.553L409.961 263.219V224.912L395.066 233.246V271.553Z",
    fill: "#001E1A"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-50-inside-9_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.566 266.44L399.194 216.327L330.628 177L243 227.113L311.566 266.44Z"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M311.566 266.44L399.194 216.327L330.628 177L243 227.113L311.566 266.44Z",
    fill: "url(#paint31_linear_3124_28296)",
    stroke: "#222222",
    strokeWidth: 2,
    mask: "url(#path-50-inside-9_3124_28296)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M247.124 347.59L254.68 343.987L268.706 334.372L278.932 327.123V321.654L256.395 309.478L245.127 307.221V312.669",
    fill: "#000508"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M258.045 332.875L271.876 324.888C272.57 324.345 273.33 323.911 274.112 323.586H274.134C277.239 322.305 281.038 322.652 285.142 324.931C295.628 330.77 304.139 347.004 304.139 361.198C304.139 369.25 301.404 374.915 297.126 377.259H297.148L280.821 386.613L281.103 383.162L284.186 376.238C284.186 376.238 284.295 376.13 284.469 375.956C274.264 369.836 266.122 353.971 266.122 340.059C266.122 338.539 266.231 337.085 266.404 335.74H264.146L258.002 332.853L258.045 332.875Z",
    fill: "#000F20"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-53-inside-10_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.686 349.543C249.686 363.737 258.197 379.993 268.683 385.81C279.17 391.648 287.681 384.855 287.681 370.66C287.681 356.466 279.17 340.21 268.683 334.394C258.197 328.556 249.686 335.349 249.686 349.543Z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M249.686 349.543C249.686 363.737 258.197 379.993 268.683 385.81C279.17 391.648 287.681 384.855 287.681 370.66C287.681 356.466 279.17 340.21 268.683 334.394C258.197 328.556 249.686 335.349 249.686 349.543Z",
    fill: "#222222",
    stroke: "url(#paint32_linear_3124_28296)",
    strokeWidth: 2,
    mask: "url(#path-53-inside-10_3124_28296)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M255.57 352.799C255.57 362.609 261.454 373.83 268.684 377.845C275.936 381.882 281.798 377.194 281.798 367.384C281.798 357.574 275.914 346.353 268.684 342.338C261.432 338.301 255.57 342.989 255.57 352.799Z",
    fill: "url(#paint33_linear_3124_28296)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M258.023 354.166C258.023 362.131 262.8 371.247 268.684 374.524C274.568 377.801 279.344 373.981 279.344 366.016C279.344 358.051 274.568 348.935 268.684 345.658C262.8 342.381 258.023 346.201 258.023 354.166Z",
    fill: "#000F20"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M259.588 355.034C259.588 361.849 263.67 369.619 268.707 372.419C273.744 375.218 277.826 371.963 277.826 365.148C277.826 358.333 273.744 350.563 268.707 347.763C263.67 344.964 259.588 348.219 259.588 355.034Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M273.343 371.486C276.942 370.024 277.784 363.735 275.224 357.438C272.664 351.142 267.671 347.224 264.072 348.686C260.472 350.148 259.63 356.438 262.19 362.734C264.75 369.03 269.743 372.949 273.343 371.486Z",
    fill: "#222222"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M270.629 364.811C272.118 364.206 272.465 361.601 271.403 358.991C270.342 356.382 268.276 354.757 266.787 355.361C265.298 355.966 264.952 358.572 266.013 361.181C267.074 363.791 269.141 365.416 270.629 364.811Z",
    fill: "#D7F0FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M264.58 358.854C264.58 361.198 265.991 363.889 267.728 364.844C269.465 365.799 270.876 364.692 270.876 362.348C270.876 360.004 269.465 357.313 267.728 356.358C265.991 355.403 264.58 356.51 264.58 358.854Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M262.15 351.106C262.02 351.04 261.912 350.954 261.781 350.845C262.281 349.955 262.932 349.282 263.714 348.87C263.779 349.152 263.822 349.456 263.822 349.738C263.822 350.997 263.062 351.605 262.129 351.084L262.15 351.106Z",
    fill: "url(#paint34_linear_3124_28296)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M262.759 362.739C263.692 363.26 264.452 364.714 264.452 365.973C264.452 366.255 264.409 366.515 264.343 366.711C263.475 365.452 262.715 364.041 262.129 362.543C262.324 362.543 262.541 362.609 262.78 362.717L262.759 362.739Z",
    fill: "url(#paint35_linear_3124_28296)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M268.706 349.283C269.249 349.587 269.792 349.955 270.313 350.39C270.096 351.193 269.466 351.518 268.706 351.106C267.946 350.693 267.317 349.652 267.1 348.61C267.621 348.762 268.163 348.979 268.706 349.283Z",
    fill: "url(#paint36_linear_3124_28296)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M262.15 355.663C262.15 356.77 261.564 357.378 260.804 357.161C260.76 356.662 260.717 356.141 260.717 355.642C260.717 354.622 260.825 353.71 261.021 352.885C261.672 353.558 262.15 354.665 262.15 355.663Z",
    fill: "url(#paint37_linear_3124_28296)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M273.202 371.529C273.05 371.116 272.963 370.66 272.963 370.248C272.963 368.989 273.723 368.382 274.656 368.902C274.939 369.054 275.221 369.315 275.438 369.619C274.852 370.552 274.092 371.203 273.18 371.55L273.202 371.529Z",
    fill: "url(#paint38_linear_3124_28296)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M268.707 368.903C269.51 369.359 270.183 370.487 270.357 371.616C269.814 371.464 269.271 371.247 268.707 370.921C268.142 370.596 267.578 370.227 267.057 369.771C267.23 368.838 267.903 368.447 268.707 368.903Z",
    fill: "url(#paint39_linear_3124_28296)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M275.285 363.477C275.285 362.435 275.784 361.871 276.479 361.957C276.61 362.826 276.696 363.694 276.696 364.54C276.696 365.191 276.653 365.821 276.566 366.407C275.828 365.756 275.285 364.54 275.285 363.477Z",
    fill: "url(#paint40_linear_3124_28296)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M274.678 357.682C273.744 357.161 272.984 355.707 272.984 354.448C272.984 354.101 273.05 353.819 273.136 353.58C274.027 354.882 274.786 356.336 275.373 357.877C275.156 357.877 274.917 357.834 274.678 357.704V357.682Z",
    fill: "url(#paint41_linear_3124_28296)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-68-inside-11_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.677 324.948L257.047 315.919L247.125 327.596V347.693L243 345.328V227L311.609 266.674L331.801 314.943L327.22 393.727L292.872 374.02C290.028 342.919 274.677 324.992 274.677 324.992V324.948Z"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M274.677 324.948L257.047 315.919L247.125 327.596V347.693L243 345.328V227L311.609 266.674L331.801 314.943L327.22 393.727L292.872 374.02C290.028 342.919 274.677 324.992 274.677 324.992V324.948Z",
    fill: "#D0E1EE",
    stroke: "#222222",
    strokeWidth: 2,
    mask: "url(#path-68-inside-11_3124_28296)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M278.34 310.371L265.356 303.708C259.082 300.995 255 294.831 255 287.995V245L305.545 274.213L314.946 312.802L317.052 356.469L295.536 344.12C290.043 325.325 278.34 310.371 278.34 310.371Z",
    fill: "#B1C8DA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M299.516 274.449L308.005 309.305L308.483 318.681L267.99 295.415V256.37L299.516 274.449Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M269.357 294.742V258.627L298.516 275.339L306.658 308.763L307.027 316.381L269.357 294.742Z",
    fill: "#161C21"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M421.296 320.83L412.633 316.293V319.809L412.98 321.741L415.26 323.022",
    fill: "#222222"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M327.199 381.925L414.827 331.812C414.827 331.812 414.328 289.294 412.417 275.144C410.419 260.45 399.216 216.349 399.216 216.349L311.588 266.462C311.588 266.462 321.901 303.966 323.594 316.467C325.809 332.832 327.199 381.925 327.199 381.925Z",
    fill: "#B1C8DA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M324.895 329.61C324.504 324.163 324.091 319.388 323.635 316.002C321.942 303.501 311.629 265.997 311.629 265.997L399.257 215.884C399.257 215.884 410.46 259.985 412.458 274.679C412.675 276.22 412.849 278.086 413.044 280.213L324.916 329.632L324.895 329.61Z",
    fill: "#161C21"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M412.675 280.387L324.677 326.659L321.16 294.624L383.19 262.633L412.675 279.692V280.387Z",
    fill: "#0F101B"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-76-inside-12_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.629 265.976C311.629 265.976 321.942 303.479 323.636 315.981C324.092 319.366 324.504 324.141 324.895 329.589L413.023 280.17C412.849 278.043 412.654 276.176 412.437 274.635C410.439 259.942 399.236 215.84 399.236 215.84L311.607 265.954L311.629 265.976ZM315.103 267.408L397.325 220.376C400.083 231.38 407.899 263.176 409.505 275.026C409.636 276.003 409.766 277.175 409.896 278.498L327.522 324.684C327.218 320.929 326.914 317.869 326.589 315.546C325.112 304.63 317.383 275.699 315.103 267.365V267.408Z"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M311.629 265.976C311.629 265.976 321.942 303.479 323.636 315.981C324.092 319.366 324.504 324.141 324.895 329.589L413.023 280.17C412.849 278.043 412.654 276.176 412.437 274.635C410.439 259.942 399.236 215.84 399.236 215.84L311.607 265.954L311.629 265.976ZM315.103 267.408L397.325 220.376C400.083 231.38 407.899 263.176 409.505 275.026C409.636 276.003 409.766 277.175 409.896 278.498L327.522 324.684C327.218 320.929 326.914 317.869 326.589 315.546C325.112 304.63 317.383 275.699 315.103 267.365V267.408Z",
    fill: "url(#paint42_linear_3124_28296)",
    stroke: "#222222",
    mask: "url(#path-76-inside-12_3124_28296)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M331.148 392.898L327.674 394.764L301.663 375.86L298.189 356.761L301.663 354.917L331.148 371.954V392.898Z",
    fill: "url(#paint43_linear_3124_28296)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M324.199 392.746L327.652 394.895L417.864 339.464L421.338 320.365L417.864 318.52L324.178 372.084L324.199 392.746Z",
    fill: "#222222"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M409.484 323.316L417.865 318.52L421.339 320.387L417.865 339.486L411.265 343.544C412.242 336.903 411.265 329.849 409.484 323.338V323.316Z",
    fill: "url(#paint44_linear_3124_28296)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M343.566 361.016L400.104 328.677C401.927 336.491 402.449 345.454 396.5 351.423C391.506 356.436 384.276 358.845 377.589 360.625C369.816 362.687 361.826 366.441 353.684 366.658C348.929 366.789 345.52 364.445 343.566 361.016Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M334.471 366.203C337.337 371.238 341.94 375.166 347.889 376.534C350.841 377.206 353.838 377.271 356.834 376.968L327.653 394.895L324.201 392.746V372.084L334.471 366.203Z",
    fill: "#222222"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M349.169 357.803L352.643 359.648L349.169 362.513L392.874 337.532V332.801L417.865 318.52V339.464L327.652 394.895L324.179 392.746L322.789 370.652L327.804 370.023L349.169 357.803Z",
    fill: "url(#paint45_linear_3124_28296)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M352.643 359.648V364.38L396.348 339.377V334.667L421.338 320.365V341.309L327.652 394.895V373.951L352.643 359.648Z",
    fill: "#222222"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M392.875 332.801L396.349 334.667V339.377L392.875 337.532V332.801Z",
    fill: "#93D7FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M341.092 211.847L366.147 226.345V220.181L341.092 210.35V211.847Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M366.147 220.159L374.94 215.081L349.885 205.336L341.113 210.415L366.147 220.159Z",
    fill: "#222222"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M366.146 226.345L374.94 221.267V215.081L366.146 220.16V226.345Z",
    fill: "#222222"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M367.189 224.631L374.072 220.702V216.774L367.189 220.724V224.631Z",
    fill: "url(#paint46_linear_3124_28296)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M317.057 224.869L342.112 239.367V233.203L317.057 223.372V224.869Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M342.112 233.181L350.905 228.103L325.85 218.358L317.078 223.437L342.112 233.181Z",
    fill: "#222222"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M342.111 239.367L350.905 234.289V228.103L342.111 233.182V239.367Z",
    fill: "#222222"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M343.154 237.653L350.037 233.724V229.796L343.154 233.746V237.653Z",
    fill: "url(#paint47_linear_3124_28296)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M293.021 237.892L318.077 252.39V246.226L293.021 236.394V237.892Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M318.077 246.204L326.87 241.125L301.815 231.38L293.021 236.459L318.077 246.204Z",
    fill: "#222222"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M318.076 252.39L326.869 247.311V241.125L318.076 246.204V252.39Z",
    fill: "#222222"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M319.119 250.675L326.002 246.747V242.818L319.119 246.768V250.675Z",
    fill: "url(#paint48_linear_3124_28296)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.551 265.693L332.017 260.267L370.751 299.008L361.241 304.347L322.551 265.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.273 238.39L404.881 272.986C404.99 273.615 405.076 274.223 405.142 274.765C405.315 276.067 405.489 277.674 405.641 279.475L380.26 293.712L341.439 254.907L370.294 238.412L370.273 238.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.484 282.101L351.319 309.925L347.237 312.226L325.656 290.652C324.939 287.744 324.201 284.836 323.506 282.123L323.484 282.101Z",
    fill: "white"
  }))), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-100-inside-13_3124_28296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.293 361.471L405.228 322.036V295.883L336.293 335.318V361.471Z"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M336.293 361.471L405.228 322.036V295.883L336.293 335.318V361.471Z",
    fill: "url(#paint49_linear_3124_28296)",
    stroke: "#222222",
    strokeWidth: 2,
    mask: "url(#path-100-inside-13_3124_28296)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M401.776 316.502L339.746 351.987V355.828L401.776 320.343V316.502ZM339.746 336.99V340.831L401.776 305.346V301.504L339.746 336.99ZM401.776 308.992L339.746 344.477V348.319L401.776 312.834V308.992Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M327.674 394.764L298.189 377.705V356.761L327.674 373.82V394.764Z",
    fill: "#222222"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M285.598 323.642L288.246 325.357V287.071L285.598 285.357V323.642Z",
    fill: "url(#paint50_linear_3124_28296)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M288.246 287.028L303.119 278.694L300.492 277.109L285.598 285.422L288.246 287.028Z",
    fill: "url(#paint51_linear_3124_28296)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M288.246 325.356L303.119 317.022V278.694L288.246 287.028V325.356Z",
    fill: "#001208"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M294.825 325.074C294.955 325.074 295.107 325.031 295.237 324.966L316.732 312.92C317.123 312.703 317.275 312.182 317.058 311.792C316.84 311.401 316.319 311.249 315.929 311.466L295.672 322.817V320.365C295.672 319.909 295.302 319.54 294.847 319.54C294.391 319.54 294.021 319.909 294.021 320.365V324.249C294.021 324.553 294.173 324.814 294.434 324.966C294.564 325.031 294.716 325.074 294.847 325.074H294.825Z",
    fill: "#001208"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M294.825 282.904C295.281 282.904 295.65 282.535 295.65 282.079V278.173L307.071 271.77C307.461 271.553 307.613 271.032 307.396 270.642C307.179 270.251 306.658 270.099 306.267 270.316L294.413 276.957C294.152 277.109 293.979 277.391 293.979 277.674V282.079C293.979 282.535 294.348 282.904 294.804 282.904H294.825Z",
    fill: "#001208"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M341.026 369.74C343.002 368.633 345.325 368.655 347.257 369.805C349.211 370.934 350.362 372.974 350.362 375.209V375.426L331.451 386.018V375.101L341.026 369.74Z",
    fill: "url(#paint52_linear_3124_28296)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M331.82 385.388L349.993 375.209C349.993 370.695 345.13 367.852 341.2 370.066L331.82 375.318V385.388Z",
    fill: "#222222"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M331.82 390.272L339.745 385.844V382.675L331.82 387.103V390.272Z",
    fill: "url(#paint53_linear_3124_28296)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M339.225 376.555C339.225 378.66 340.549 379.615 342.177 378.66C343.806 377.705 345.13 375.231 345.13 373.126C345.13 371.02 343.806 370.065 342.177 371.02C340.549 371.975 339.225 374.45 339.225 376.555Z",
    fill: "#FFFFFD"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M334.6 379.441C334.6 380.635 335.36 381.178 336.271 380.635C337.205 380.092 337.943 378.682 337.943 377.488C337.943 376.294 337.183 375.752 336.271 376.294C335.338 376.837 334.6 378.248 334.6 379.441Z",
    fill: "#FFFFFD"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M410.005 329.523C411.98 328.416 419.341 324.119 419.341 324.119V335.21L400.43 345.801V344.716C400.43 338.639 403.708 333.039 409.028 330.066L410.005 329.523Z",
    fill: "url(#paint54_linear_3124_28296)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M400.799 345.172L418.972 334.993V324.922L409.592 330.175C404.164 333.213 400.799 338.943 400.799 345.172Z",
    fill: "#222222"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M410.916 344.846L418.841 340.418V337.271L410.916 341.699V344.846Z",
    fill: "url(#paint55_linear_3124_28296)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M411.09 334.515C411.09 336.62 412.414 337.575 414.043 336.62C415.671 335.666 416.995 333.191 416.995 331.086C416.995 328.981 415.671 328.026 414.043 328.981C412.414 329.936 411.09 332.41 411.09 334.515Z",
    fill: "#FFFFFD"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M406.117 337.966C406.117 339.159 406.877 339.702 407.789 339.159C408.723 338.617 409.461 337.206 409.461 336.012C409.461 334.819 408.701 334.276 407.789 334.819C406.855 335.361 406.117 336.772 406.117 337.966Z",
    fill: "#FFFFFD"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M277.823 304.825L268.77 299.898V297.164L277.823 302.069V304.825Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M111.488 47.4325L86.2756 61.9875L80.5678 58.6924L91.4232 52.4257L81.1281 46.4823L70.2728 52.7491L64.565 49.454L89.7773 34.8989L95.4851 38.194L85.9605 43.6926L96.2555 49.6359L105.78 44.1374L111.488 47.4325Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M120.274 70.7815C114.461 74.1373 106.057 73.9351 99.9643 70.4177C93.8363 66.88 93.5212 62.0485 99.334 58.6927C105.112 55.3572 113.516 55.5189 119.644 59.0566C125.737 62.5741 126.052 67.446 120.274 70.7815ZM114.637 67.5269C118.628 65.2223 118.348 63.4029 115.232 61.6037C112.08 59.7844 108.964 59.6429 104.972 61.9474C100.945 64.2722 101.225 66.0511 104.376 67.8705C107.493 69.6697 110.61 69.8516 114.637 67.5269Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M127.176 80.5066L122.763 83.0537L121.888 82.5483C116.986 79.7182 116.705 76.605 121.083 74.0781L142.373 61.7871L147.801 64.9205L126.685 77.1104C124.584 78.3233 124.724 79.0915 126.58 80.1629L127.176 80.5066Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M186.669 98.275L170.211 107.776C163.873 111.435 157.29 111.718 149.796 107.392C144.193 104.158 144.298 101.186 146.714 98.2548L151.932 101.267C150.952 102.48 151.827 103.592 154.173 104.946C157.78 107.028 160.091 107.352 164.153 105.007L165.694 104.117C163.138 104.461 160.686 104.218 157.465 102.359C152.667 99.589 152.037 94.7778 157.36 91.705C162.822 88.5514 170.946 88.6727 176.059 91.6242C179.14 93.4031 179.385 95.2023 178.79 96.5567L181.241 95.1416L186.669 98.275ZM173.748 99.4677C175.393 97.5877 175.604 96.4152 172.347 94.5352C169.686 92.9988 166.534 92.918 162.997 94.9597C159.041 97.244 159.461 98.8613 162.192 100.438C165.694 102.46 167.76 102.278 170.806 101.166L173.748 99.4677Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M203.827 108.1L198.784 111.011C198.469 110.546 197.769 109.98 196.718 109.374C193.637 107.595 190.1 107.251 186.143 109.536L177.389 114.59L171.961 111.456L190.73 100.621L196.158 103.754L193.427 105.331C196.333 104.745 199.555 105.189 202.076 106.645C202.881 107.11 203.547 107.656 203.827 108.1Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M210.761 128.76L206.349 131.308L205.544 130.843C202.462 129.064 202.147 127.952 202.812 126.638C200.361 127.083 196.649 126.234 193.603 124.475C189.751 122.251 187.93 118.976 192.132 116.55C196.264 114.165 202.357 115.621 206.384 117.945C207.866 118.771 208.983 119.79 209.641 120.917L211.041 120.108C213.212 118.855 213.387 117.945 210.761 116.429C208.94 115.378 207.715 114.994 205.894 115.519L200.606 112.467C206.104 110.829 210.831 111.699 214.858 114.023C220.531 117.298 220.951 120.654 216.259 123.363L210.411 126.739C209.185 127.446 209.395 127.972 210.306 128.498L210.761 128.76ZM206.139 122.938C205.859 122.009 205.368 121.281 203.162 120.007C200.921 118.713 199.556 118.693 197.91 119.643C196.369 120.533 196.404 121.321 198.435 122.494C200.536 123.707 201.937 124.192 204.318 123.99L206.139 122.938Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M250.013 124.132L245.636 126.659C244.95 125.938 244.089 125.278 243.08 124.698C241.434 123.748 239.683 123.627 237.687 124.779L235.131 126.255L240.384 129.287L235.971 131.834L230.719 128.802L216.362 137.09L210.934 133.957L225.291 125.668L221.579 123.526L225.992 120.978L229.703 123.121L232.295 121.625C236.427 119.24 242.66 119.361 246.617 121.645C247.921 122.391 249.061 123.226 250.013 124.132Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M154.983 90.1253C149.369 93.3663 141.181 93.13 135.199 89.6766C129.181 86.2024 128.806 81.4954 134.42 78.2544C140.001 75.0329 148.188 75.2298 154.206 78.704C160.188 82.1594 160.564 86.9038 154.983 90.1253Z",
    fill: "#222222",
    stroke: "url(#paint56_radial_3124_28296)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M140.383 88.6853C143.202 90.3126 146.805 91.4089 150.704 91.8259C145.675 93.0813 139.786 92.3275 135.197 89.6781C132.974 88.3947 131.522 86.9417 130.856 85.458C131.954 85.3845 133.069 85.4567 134.119 85.669C135.169 85.8813 136.125 86.2281 136.915 86.6832L140.383 88.6853ZM143.794 86.7163L140.326 84.7141C139.049 83.9767 137.508 83.4095 135.816 83.0532C134.124 82.697 132.323 82.5606 130.541 82.654C130.436 83.1231 130.411 83.5977 130.466 84.0711C131.94 83.966 133.442 84.0582 134.855 84.3406C136.269 84.6231 137.556 85.0882 138.618 85.7001L142.086 87.7023C145.272 89.5419 149.566 90.593 154.035 90.6272C154.359 90.4703 154.673 90.3045 154.979 90.1278C155.516 89.8185 156.01 89.4855 156.457 89.1318C154.183 89.3341 151.848 89.2206 149.647 88.8006C147.445 88.3806 145.439 87.6662 143.794 86.7163ZM152.32 81.7942C152.78 82.0593 153.4 82.2099 154.045 82.213C154.689 82.2161 155.305 82.0714 155.758 81.8108L157.187 80.9859C156.387 80.1476 155.381 79.3791 154.202 78.7046C149.806 76.1664 144.253 75.3797 139.404 76.3939C142.953 77.0939 146.186 78.2571 148.849 79.7921L152.32 81.7942ZM148.909 83.7633C150.229 84.5225 151.989 84.9696 153.836 85.0145C155.683 85.0594 157.479 84.6987 158.862 84.0051C158.755 83.4528 158.547 82.9076 158.24 82.3789L157.491 82.8114C156.586 83.3326 155.353 83.6217 154.064 83.6155C152.774 83.6093 151.533 83.3082 150.612 82.7782L147.146 80.7771C144.168 79.0567 140.408 77.8607 136.316 77.3329C135.639 77.6084 135.004 77.9172 134.418 78.2559C134.271 78.3408 134.128 78.4238 133.992 78.5137C138.311 78.8286 142.344 79.973 145.44 81.7621L148.909 83.7633ZM142.031 83.7301L145.499 85.7323C147.122 86.6679 149.16 87.326 151.381 87.6317C153.602 87.9374 155.916 87.8783 158.061 87.4612C158.444 86.9054 158.704 86.323 158.836 85.7276C156.997 86.3144 154.867 86.5362 152.768 86.3593C150.67 86.1825 148.717 85.6165 147.205 84.7473L143.737 82.7451C140.669 80.9762 136.57 79.9359 132.271 79.8353C131.805 80.2758 131.419 80.7437 131.121 81.2315C133.127 81.193 135.133 81.3951 137.01 81.8252C138.888 82.2552 140.597 82.9039 142.031 83.7301Z",
    fill: "url(#paint57_radial_3124_28296)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M154.983 90.1253C149.369 93.3663 141.181 93.13 135.199 89.6766C129.181 86.2024 128.806 81.4954 134.42 78.2544C140.001 75.0329 148.188 75.2298 154.206 78.704C160.188 82.1594 160.564 86.9038 154.983 90.1253Z",
    stroke: "url(#paint58_radial_3124_28296)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M243.44 139.467C246.335 141.952 249.508 145.044 245.319 147.462C240.848 150.043 234.86 148.415 230.422 145.853C225.214 142.847 224.425 140.034 227.636 137.051L232.773 140.016C231.785 140.99 231.64 141.76 234.401 143.354C236.777 144.726 238.248 145.128 239.41 144.457C240.747 143.685 240.47 143.24 238.063 141.159C235.306 138.796 231.785 135.422 236.08 132.942C240.058 130.646 245.768 131.869 250.311 134.492C254.994 137.196 255.958 140.109 253.03 142.809L247.892 139.843C248.6 138.869 248.533 138.262 246.332 136.991C243.99 135.639 242.693 135.46 241.602 136.09C240.581 136.679 240.963 137.347 243.44 139.467Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.851 195.418C116.613 201.333 124.708 203.192 131.477 200.632C130.692 203.605 129.6 206.106 128.244 208.142C121.79 208.665 114.728 206.208 107.928 201.029L99.2027 194.394C97.2268 192.882 95.1641 191.981 93.2041 191.743C91.3916 191.533 89.7163 191.885 88.2429 192.781C87.1306 190.838 86.1358 188.84 85.2733 186.791C87.2657 185.505 89.5884 184.97 92.0767 185.249C94.7127 185.555 97.4825 186.761 100.144 188.772L108.869 195.407L108.851 195.418Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.934 197.115L133.628 197.647L133.47 198.55L132.79 198.022L132.934 197.115Z",
    fill: "url(#paint59_linear_3124_28296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.069 162.801L124.361 161.035C125.744 163.245 126.954 165.56 128.028 167.94C128.008 168.043 127.977 168.129 127.945 168.215C127.896 168.389 127.867 168.46 127.85 168.549C127.801 168.723 127.77 168.809 127.741 168.88C127.677 169.052 127.645 169.137 127.631 169.211C127.568 169.383 127.539 169.454 127.507 169.539C127.443 169.711 127.415 169.782 127.386 169.853C127.307 170.022 127.278 170.093 127.249 170.164C127.171 170.332 127.142 170.403 127.113 170.474C127.035 170.643 126.991 170.711 126.965 170.768C126.872 170.933 126.846 170.99 126.817 171.061C126.724 171.227 126.698 171.283 126.657 171.336C126.567 171.487 126.523 171.556 126.497 171.612C126.407 171.763 126.366 171.816 126.325 171.87C126.135 172.14 125.99 172.341 125.844 172.543C125.759 172.665 125.721 172.703 125.683 172.742C125.663 172.768 125.625 172.807 125.604 172.834C125.566 172.872 125.528 172.911 125.505 172.953C125.467 172.991 125.446 173.018 125.408 173.057C125.37 173.095 125.332 173.134 125.309 173.175C125.271 173.214 125.248 173.255 125.212 173.279C125.174 173.318 125.139 173.342 125.116 173.383C125.078 173.422 125.04 173.461 125.005 173.484C124.967 173.523 124.931 173.547 124.908 173.588C124.87 173.627 124.832 173.666 124.797 173.69C124.762 173.713 124.724 173.752 124.688 173.776C124.65 173.815 124.615 173.838 124.577 173.877C124.542 173.901 124.504 173.94 124.469 173.963C124.431 174.002 124.395 174.026 124.343 174.062C124.307 174.086 124.272 174.109 124.234 174.148C124.196 174.187 124.146 174.208 124.108 174.246C124.073 174.27 124.038 174.294 124.003 174.318C123.965 174.357 123.915 174.378 123.877 174.416C123.841 174.44 123.806 174.464 123.771 174.488C123.721 174.509 123.683 174.548 123.633 174.569C123.598 174.593 123.563 174.616 123.527 174.64C123.477 174.661 123.439 174.7 123.389 174.721C123.354 174.745 123.322 174.754 123.287 174.778C123.237 174.799 123.184 174.835 123.134 174.856C123.099 174.88 123.066 174.889 123.031 174.913C122.981 174.934 122.928 174.969 122.878 174.99C122.846 174.999 122.811 175.023 122.778 175.032C122.728 175.053 122.661 175.086 122.611 175.107C122.443 175.183 122.346 175.21 122.264 175.24C119.364 176.307 115.92 175.508 112.606 172.989L103.877 166.369C103.756 166.284 103.637 166.185 103.515 166.1C103.328 165.957 103.248 165.896 103.153 165.832C103.1 165.791 103.059 165.768 103.005 165.727C102.94 165.668 102.857 165.622 102.789 165.578C102.735 165.537 102.682 165.496 102.626 165.47C102.558 165.426 102.492 165.368 102.424 165.324C102.371 165.283 102.302 165.24 102.249 165.199C102.181 165.155 102.127 165.114 102.059 165.071C101.991 165.027 101.938 164.986 101.87 164.942C101.816 164.901 101.748 164.858 101.695 164.817C101.641 164.776 101.573 164.732 101.52 164.691C101.466 164.651 101.398 164.607 101.345 164.566C101.276 164.522 101.223 164.481 101.155 164.438C101.101 164.397 101.033 164.353 100.977 164.327C100.909 164.283 100.855 164.243 100.787 164.199C100.734 164.158 100.678 164.132 100.624 164.091C100.556 164.047 100.488 164.004 100.434 163.963C100.381 163.922 100.325 163.896 100.271 163.855C100.203 163.811 100.135 163.767 100.064 163.739C100.008 163.712 99.9544 163.672 99.8982 163.645C99.83 163.602 99.7619 163.558 99.6909 163.529C99.6346 163.503 99.596 163.465 99.5397 163.439C99.4716 163.395 99.4034 163.351 99.3176 163.32C99.2614 163.294 99.2199 163.27 99.1665 163.229C99.0983 163.186 99.0154 163.139 98.9444 163.11C98.9029 163.087 98.8467 163.061 98.8052 163.038C98.737 162.994 98.6541 162.947 98.5831 162.918C98.5416 162.895 98.4854 162.869 98.4439 162.846C98.3757 162.802 98.29 162.77 98.2218 162.727C98.1775 162.718 98.1388 162.68 98.0826 162.654C97.9997 162.607 97.9287 162.579 97.8457 162.532C97.8014 162.524 97.7628 162.485 97.7213 162.462C97.6384 162.416 97.5674 162.387 97.4844 162.34C97.4401 162.332 97.4015 162.294 97.36 162.27C97.2771 162.224 97.2061 162.195 97.1231 162.148C97.0788 162.14 97.0402 162.102 96.9959 162.093C96.9129 162.047 96.8419 162.018 96.759 161.971C96.7147 161.963 96.6732 161.94 96.6465 161.919C96.5636 161.873 96.4778 161.841 96.392 161.809C96.3477 161.801 96.321 161.78 96.2796 161.757C96.1938 161.725 96.1108 161.679 96.0251 161.647C95.8416 161.566 95.7439 161.516 95.6581 161.485C95.4746 161.403 95.3888 161.372 95.2911 161.322C95.1224 161.244 95.0219 161.209 94.9213 161.175C94.7498 161.111 94.6521 161.062 94.5663 161.03C94.3948 160.967 94.2942 160.932 94.1965 160.883C94.0397 160.822 93.9392 160.787 93.8386 160.753C93.6966 160.695 93.5813 160.657 93.4808 160.623C93.3507 160.583 93.2354 160.545 93.1229 160.493C89.0632 159.147 85.1028 158.801 81.3716 159.494C81.4192 159.166 81.4668 158.838 81.5291 158.514C81.878 156.376 82.3758 154.419 82.9873 152.669C83.0935 152.674 83.1878 152.661 83.2792 152.663C83.4178 152.659 83.5092 152.662 83.6183 152.652C83.7569 152.648 83.8483 152.65 83.9397 152.652C84.0931 152.651 84.1845 152.653 84.2612 152.653C84.4146 152.652 84.506 152.654 84.5974 152.656C84.7508 152.655 84.8422 152.657 84.9308 152.674C85.0813 152.688 85.1728 152.69 85.2642 152.692C85.4147 152.706 85.5062 152.708 85.5976 152.71C85.7481 152.724 85.8396 152.726 85.931 152.728C86.0815 152.742 86.173 152.744 86.2616 152.761C86.4092 152.789 86.5007 152.792 86.5921 152.794C86.7546 152.825 86.846 152.827 86.9375 152.829C87.0851 152.858 87.1766 152.86 87.2799 152.88C87.4276 152.908 87.531 152.928 87.6224 152.93C87.7849 152.961 87.8735 152.978 87.9621 152.995C88.1098 153.024 88.2132 153.044 88.3018 153.061C88.4642 153.092 88.5528 153.109 88.6414 153.126C88.8039 153.157 88.8925 153.174 88.9811 153.191C89.1288 153.219 89.2321 153.239 89.3207 153.256C89.4684 153.284 89.557 153.301 89.6604 153.321C89.7933 153.347 89.8967 153.367 90.0001 153.386C90.133 153.412 90.2364 153.432 90.3369 153.466C91.6075 153.787 92.8492 154.178 94.1063 154.649C94.2216 154.686 94.3193 154.736 94.4199 154.77C94.5471 154.825 94.6477 154.86 94.7482 154.894C94.8902 154.952 94.9908 154.987 95.0885 155.036C95.2452 155.097 95.3282 155.144 95.4287 155.178C95.5974 155.256 95.6832 155.288 95.769 155.32C95.9525 155.401 96.0382 155.433 96.1064 155.477C96.1507 155.485 96.1774 155.506 96.2189 155.529C96.3047 155.561 96.3728 155.604 96.4586 155.636C96.5029 155.645 96.5296 155.665 96.5711 155.688C96.6421 155.717 96.725 155.764 96.796 155.793C96.8404 155.801 96.8818 155.824 96.9233 155.848C96.9943 155.877 97.0772 155.923 97.1482 155.952C97.1925 155.961 97.2312 155.999 97.2755 156.007C97.3465 156.036 97.4147 156.08 97.4857 156.109C97.53 156.117 97.5834 156.158 97.6249 156.181C97.6959 156.21 97.764 156.254 97.835 156.283C97.8793 156.291 97.9327 156.332 97.9742 156.356C98.0452 156.384 98.1134 156.428 98.1844 156.457C98.2259 156.48 98.2821 156.506 98.3236 156.53C98.3918 156.573 98.4628 156.602 98.5309 156.646C98.5872 156.672 98.6286 156.695 98.6849 156.722C98.7531 156.765 98.8241 156.794 98.8922 156.838C98.9485 156.864 98.9899 156.887 99.0462 156.913C99.1144 156.957 99.1854 156.986 99.2535 157.03C99.3098 157.056 99.3512 157.079 99.4046 157.12C99.4728 157.164 99.5438 157.193 99.5972 157.233C99.6535 157.26 99.6921 157.298 99.7483 157.324C99.8165 157.367 99.8875 157.396 99.9409 157.437C99.9972 157.463 100.036 157.501 100.092 157.527C100.16 157.571 100.216 157.597 100.285 157.641C100.341 157.667 100.394 157.708 100.451 157.734C100.519 157.778 100.575 157.804 100.643 157.848C100.696 157.888 100.753 157.914 100.806 157.955C100.86 157.996 100.931 158.025 100.984 158.066C101.037 158.107 101.094 158.133 101.162 158.177C101.215 158.218 101.286 158.246 101.34 158.287C101.393 158.328 101.449 158.354 101.503 158.395C101.556 158.436 101.624 158.48 101.68 158.506C101.734 158.547 101.79 158.573 101.843 158.614C101.897 158.655 101.965 158.698 102.021 158.724C102.075 158.765 102.131 158.791 102.184 158.832C102.238 158.873 102.306 158.917 102.359 158.958C102.413 158.999 102.481 159.042 102.534 159.083C102.588 159.124 102.641 159.165 102.712 159.194C102.766 159.235 102.834 159.278 102.902 159.322C102.955 159.363 103.009 159.404 103.065 159.43C103.133 159.474 103.187 159.514 103.255 159.558C103.308 159.599 103.362 159.64 103.418 159.666C103.486 159.71 103.551 159.768 103.619 159.812C103.658 159.85 103.714 159.876 103.753 159.914C103.821 159.958 103.886 160.016 103.955 160.06C104.008 160.101 104.049 160.124 104.103 160.165C104.183 160.226 104.263 160.288 104.331 160.331C104.373 160.355 104.397 160.39 104.438 160.413C104.56 160.498 104.666 160.579 104.785 160.679L113.496 167.311C115.807 169.071 118.223 169.565 120.21 168.706C122.194 167.862 123.575 165.692 124.083 162.727L124.069 162.801Z",
    fill: "url(#paint60_linear_3124_28296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.499 167.372L104.789 160.74C97.5201 155.211 89.9572 152.413 82.9727 152.665C83.8292 150.196 84.9335 148.111 86.2533 146.419C92.6419 147.278 99.2978 150.254 105.724 155.147L114.452 161.767C115.601 162.645 116.806 162.907 117.793 162.469C118.793 162.048 119.489 160.972 119.731 159.472L120.401 155.421C121.836 157.197 123.163 159.059 124.382 161.008L124.089 162.773C123.582 165.738 122.201 167.908 120.217 168.752C118.23 169.611 115.828 169.12 113.502 167.357L113.499 167.372Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28 195.178C126.135 195.52 129.713 194.583 132.74 192.377C132.649 193.967 132.484 195.543 132.216 197.1C132.008 198.346 131.752 199.522 131.463 200.63C124.694 203.19 116.598 201.33 108.837 195.416L100.112 188.781C97.4506 186.77 94.6836 185.55 92.0448 185.259C89.5565 184.98 87.2366 185.5 85.2414 186.801C85.1243 186.534 85.022 186.269 84.9049 186.002C84.1561 184.158 83.5044 182.288 82.9498 180.39C85.4214 178.92 88.266 178.378 91.2923 178.806C94.4838 179.25 97.8103 180.745 101.017 183.183L109.743 189.818C113.873 192.953 118.157 194.801 122.251 195.172L122.28 195.178Z",
    fill: "url(#paint61_linear_3124_28296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.556 169.228C133.291 178.411 134.724 188.501 133.175 197.85C131.626 207.199 127.532 213.135 121.931 215.199C116.314 217.261 109.196 215.497 101.58 209.703C93.9639 203.908 87.8679 195.619 84.1302 186.45C80.3925 177.281 78.9892 167.197 80.5464 157.804C82.1036 148.41 86.1539 142.542 91.7558 140.478C97.3634 138.384 104.487 140.119 112.157 145.954C119.77 151.763 125.821 160.044 129.553 169.242L129.556 169.228ZM131.475 200.647C131.764 199.539 132.02 198.363 132.229 197.117C133.727 188.111 132.348 178.46 128.769 169.658C125.176 160.854 119.377 152.851 111.96 147.218C104.543 141.584 97.6406 139.892 92.2653 141.893C88.175 143.42 84.9507 147.058 82.9807 152.697C82.3692 154.448 81.8714 156.404 81.5225 158.542C81.4601 158.867 81.4126 159.195 81.365 159.522C81.0383 161.864 80.8917 164.224 80.9103 166.601C80.9346 168.948 81.1447 171.285 81.4904 173.633C81.8328 175.919 82.3489 178.177 82.9916 180.413C83.5462 182.311 84.1951 184.196 84.9467 186.025C85.0491 186.289 85.1662 186.557 85.2833 186.824C86.1605 188.876 87.1553 190.874 88.2529 192.814C91.7154 198.868 96.3114 204.282 101.803 208.459C109.217 214.108 116.081 215.761 121.451 213.791C124.121 212.802 126.424 210.932 128.269 208.178C129.625 206.141 130.717 203.641 131.502 200.668",
    fill: "url(#paint62_linear_3124_28296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1618 158.749L82.3105 151.804L83.2304 152.516L82.0844 159.447L81.1618 158.749Z",
    fill: "url(#paint63_linear_3124_28296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2037 194.394L107.929 201.029C114.729 206.208 121.806 208.668 128.245 208.142C126.415 210.899 124.109 212.784 121.427 213.755C116.057 215.726 109.193 214.072 101.779 208.424C96.2876 204.246 91.7065 198.835 88.2291 192.779C89.6878 191.879 91.3807 191.515 93.1903 191.74C95.1504 191.978 97.213 192.879 99.189 194.391L99.2037 194.394Z",
    fill: "url(#paint64_linear_3124_28296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2528 141.876C97.6105 139.887 104.492 141.529 111.948 147.201C115.06 149.574 117.895 152.353 120.397 155.436L119.726 159.488C119.485 160.988 118.788 162.064 117.789 162.484C116.801 162.923 115.596 162.661 114.448 161.782L105.72 155.162C105.521 155.001 105.304 154.853 105.105 154.692C105.037 154.648 104.972 154.59 104.918 154.549C104.785 154.447 104.637 154.342 104.503 154.24C104.423 154.178 104.328 154.114 104.248 154.053C104.126 153.968 104.005 153.884 103.883 153.799C103.788 153.735 103.708 153.674 103.613 153.61C103.492 153.525 103.385 153.443 103.261 153.374C103.166 153.309 103.071 153.245 102.976 153.181C102.866 153.114 102.76 153.032 102.65 152.965C102.555 152.901 102.445 152.834 102.351 152.77C102.241 152.703 102.131 152.636 102.024 152.555C101.93 152.49 101.82 152.423 101.725 152.359C101.615 152.292 101.521 152.228 101.411 152.161C101.301 152.094 101.206 152.03 101.097 151.963C100.987 151.896 100.892 151.832 100.78 151.78C100.67 151.713 100.575 151.649 100.463 151.597C100.368 151.532 100.255 151.48 100.161 151.416C100.051 151.349 99.9384 151.297 99.8435 151.233C99.7458 151.183 99.6509 151.119 99.5385 151.067C99.4288 151 99.3163 150.948 99.2067 150.881C99.109 150.832 99.0141 150.767 98.9164 150.718C98.8068 150.651 98.6943 150.599 98.5818 150.547C98.4841 150.497 98.3864 150.448 98.2887 150.399C98.1762 150.346 98.0666 150.279 97.9541 150.227C97.8564 150.178 97.7734 150.131 97.6757 150.082C97.5632 150.03 97.4536 149.963 97.3411 149.91C97.2434 149.861 97.1605 149.815 97.0599 149.78C96.9475 149.728 96.835 149.676 96.7225 149.623C96.6248 149.574 96.539 149.542 96.4413 149.493C96.3288 149.441 96.2016 149.386 96.0891 149.333C96.0033 149.302 95.9204 149.255 95.8199 149.221C95.6926 149.166 95.5801 149.113 95.4529 149.058C95.3671 149.026 95.2842 148.98 95.1984 148.948C95.0712 148.893 94.9587 148.841 94.8286 148.801C94.7428 148.769 94.6571 148.737 94.5861 148.708C94.4588 148.653 94.3287 148.613 94.2163 148.561C94.1305 148.529 94.0595 148.5 93.9737 148.468C93.8465 148.413 93.7164 148.373 93.5891 148.318C93.5153 148.304 93.4471 148.26 93.3733 148.246C93.246 148.191 93.1012 148.148 92.9711 148.107C92.8973 148.093 92.841 148.067 92.77 148.038C92.6252 147.995 92.4832 147.937 92.3383 147.894C92.2793 147.883 92.2202 147.872 92.1639 147.845C92.0191 147.802 91.8623 147.742 91.7175 147.699C91.6732 147.69 91.6436 147.684 91.5993 147.676C90.6297 147.383 89.6544 147.119 88.6826 146.917C88.4906 146.88 88.3282 146.849 88.1509 146.815C88.1214 146.81 88.0771 146.801 88.0476 146.795C87.8999 146.767 87.7374 146.736 87.5898 146.708C87.5455 146.699 87.4864 146.688 87.4421 146.679C87.2944 146.651 87.1615 146.625 87.0138 146.597C86.9548 146.586 86.8957 146.574 86.8366 146.563C86.7037 146.538 86.5708 146.512 86.435 146.501C86.3907 146.493 86.3317 146.481 86.2874 146.473C87.9749 144.301 89.9979 142.775 92.3062 141.917L92.2528 141.876Z",
    fill: "url(#paint65_linear_3124_28296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.066 183.176C97.8589 180.738 94.5323 179.243 91.3408 178.799C88.3146 178.371 85.4671 178.927 82.9983 180.383C82.3556 178.147 81.8571 175.877 81.4971 173.603C84.3942 172.23 87.6558 171.829 91.0756 172.44C94.6875 173.087 98.4112 174.827 102.004 177.568L110.729 184.203C114.806 187.297 119.053 188.862 122.971 188.71C126.674 188.563 129.967 186.883 132.491 183.861C132.832 186.713 132.928 189.564 132.771 192.382C129.747 194.573 126.18 195.527 122.311 195.183C118.236 194.799 113.933 192.963 109.803 189.828L101.078 183.193L101.066 183.176Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.904 182.038C126.238 181.422 128.98 179.177 130.813 175.609C131.578 178.328 132.136 181.084 132.477 183.859C129.949 186.896 126.674 188.564 122.956 188.708C119.038 188.86 114.791 187.295 110.715 184.201L101.989 177.566C98.3963 174.825 94.6726 173.084 91.0608 172.437C87.6409 171.827 84.3794 172.227 81.4823 173.601C81.1189 171.265 80.9265 168.916 80.9022 166.569C87.5496 164.322 95.3915 166.225 102.927 171.958L111.653 178.593C115.45 181.465 119.4 182.667 122.907 182.023L122.904 182.038Z",
    fill: "url(#paint66_linear_3124_28296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.635 178.604L102.909 171.97C95.3735 166.237 87.5316 164.334 80.8842 166.58C80.8507 164.201 80.9974 161.84 81.3388 159.502C88.3592 158.184 96.2434 160.585 103.83 166.374L112.558 172.994C115.872 175.513 119.32 176.297 122.216 175.245C124.951 174.238 126.995 171.645 128.013 167.936C128.271 168.506 128.514 169.073 128.74 169.652C129.528 171.61 130.219 173.596 130.781 175.617C128.948 179.185 126.205 181.43 122.871 182.046C119.364 182.69 115.415 181.489 111.617 178.616L111.635 178.604Z",
    fill: "#0E0E0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3124_28296",
    x1: 45.8583,
    y1: 230.121,
    x2: 126.632,
    y2: 191.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3124_28296",
    x1: 190.913,
    y1: 345.281,
    x2: 265.612,
    y2: 314.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3124_28296",
    x1: 236.009,
    y1: 342.301,
    x2: 260.46,
    y2: 337.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3124_28296",
    x1: 51.725,
    y1: 234.156,
    x2: 74.0389,
    y2: 224.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3124_28296",
    x1: 60.0526,
    y1: 270.078,
    x2: 91.3941,
    y2: 262.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3124_28296",
    x1: 67.7444,
    y1: 252.807,
    x2: 75.2636,
    y2: 250.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3124_28296",
    x1: 64.6623,
    y1: 238.184,
    x2: 67.0204,
    y2: 237.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3124_28296",
    x1: 65.0286,
    y1: 253.814,
    x2: 67.8636,
    y2: 253.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3124_28296",
    x1: 70.0582,
    y1: 238.228,
    x2: 73.4552,
    y2: 236.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3124_28296",
    x1: 63.5576,
    y1: 244.324,
    x2: 65.3555,
    y2: 244.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3124_28296",
    x1: 75.8726,
    y1: 258.51,
    x2: 78.7179,
    y2: 257.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3124_28296",
    x1: 70.0209,
    y1: 258.561,
    x2: 73.5731,
    y2: 257.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3124_28296",
    x1: 78.1246,
    y1: 253.52,
    x2: 79.8977,
    y2: 253.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3124_28296",
    x1: 75.8884,
    y1: 244.973,
    x2: 78.8036,
    y2: 244.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3124_28296",
    x1: 61.9238,
    y1: 260.839,
    x2: 117.358,
    y2: 235.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3124_28296",
    x1: 99.2738,
    y1: 261.459,
    x2: 121.588,
    y2: 251.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3124_28296",
    x1: 107.601,
    y1: 297.381,
    x2: 138.943,
    y2: 289.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3124_28296",
    x1: 115.272,
    y1: 280.109,
    x2: 122.791,
    y2: 278.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3124_28296",
    x1: 112.19,
    y1: 265.487,
    x2: 114.548,
    y2: 264.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3124_28296",
    x1: 112.556,
    y1: 281.117,
    x2: 115.391,
    y2: 280.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3124_28296",
    x1: 117.586,
    y1: 265.53,
    x2: 120.983,
    y2: 263.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3124_28296",
    x1: 111.085,
    y1: 271.627,
    x2: 112.883,
    y2: 271.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3124_28296",
    x1: 123.421,
    y1: 285.813,
    x2: 126.267,
    y2: 284.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3124_28296",
    x1: 117.548,
    y1: 285.864,
    x2: 121.1,
    y2: 284.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3124_28296",
    x1: 125.652,
    y1: 280.823,
    x2: 127.425,
    y2: 280.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3124_28296",
    x1: 123.416,
    y1: 272.275,
    x2: 126.331,
    y2: 271.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3124_28296",
    x1: 109.473,
    y1: 288.142,
    x2: 164.907,
    y2: 262.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3124_28296",
    x1: 15.6049,
    y1: 337.569,
    x2: 283.491,
    y2: 243.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3124_28296",
    x1: 22.0838,
    y1: 211.045,
    x2: 318.207,
    y2: 15.2304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3124_28296",
    x1: 242.486,
    y1: 328.86,
    x2: 362.068,
    y2: 303.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3124_28296",
    x1: 393.598,
    y1: 234.315,
    x2: 409.079,
    y2: 224.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3124_28296",
    x1: 253.328,
    y1: 276.056,
    x2: 392.118,
    y2: 184.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3124_28296",
    x1: 252.198,
    y1: 393.881,
    x2: 297.598,
    y2: 382.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3124_28296",
    x1: 257.305,
    y1: 383.423,
    x2: 288.646,
    y2: 375.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3124_28296",
    x1: 261.916,
    y1: 351.529,
    x2: 264.274,
    y2: 350.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3124_28296",
    x1: 262.283,
    y1: 367.159,
    x2: 265.118,
    y2: 366.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3124_28296",
    x1: 267.312,
    y1: 351.572,
    x2: 270.709,
    y2: 350.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3124_28296",
    x1: 260.812,
    y1: 357.669,
    x2: 262.609,
    y2: 357.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3124_28296",
    x1: 273.127,
    y1: 371.855,
    x2: 275.972,
    y2: 370.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3124_28296",
    x1: 267.275,
    y1: 371.928,
    x2: 270.827,
    y2: 370.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3124_28296",
    x1: 275.378,
    y1: 366.886,
    x2: 277.152,
    y2: 366.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3124_28296",
    x1: 273.142,
    y1: 358.339,
    x2: 276.058,
    y2: 357.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3124_28296",
    x1: 318.313,
    y1: 341.818,
    x2: 434.411,
    y2: 302.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3124_28296",
    x1: 300.369,
    y1: 399.048,
    x2: 338.641,
    y2: 387.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3124_28296",
    x1: 410.268,
    y1: 346.235,
    x2: 424.907,
    y2: 343.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3124_28296",
    x1: 329.076,
    y1: 403.106,
    x2: 428.336,
    y2: 356.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3124_28296",
    x1: 367.645,
    y1: 225.475,
    x2: 375.551,
    y2: 222.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3124_28296",
    x1: 343.609,
    y1: 238.497,
    x2: 351.516,
    y2: 235.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3124_28296",
    x1: 319.574,
    y1: 251.52,
    x2: 327.481,
    y2: 248.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3124_28296",
    x1: 340.851,
    y1: 368.523,
    x2: 416.76,
    y2: 338.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3124_28296",
    x1: 285.773,
    y1: 329.657,
    x2: 289.146,
    y2: 329.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3124_28296",
    x1: 286.756,
    y1: 288.094,
    x2: 302.217,
    y2: 277.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3124_28296",
    x1: 332.702,
    y1: 387.855,
    x2: 353.224,
    y2: 379.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3124_28296",
    x1: 332.344,
    y1: 391.088,
    x2: 341.088,
    y2: 387.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3124_28296",
    x1: 401.68,
    y1: 348.132,
    x2: 423.424,
    y2: 340.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3124_28296",
    x1: 411.44,
    y1: 345.66,
    x2: 420.177,
    y2: 342.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_3124_28296",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.884 85.4006) rotate(8.70893) scale(59.8246 18.5773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_3124_28296",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.882 85.402) rotate(8.70883) scale(59.8247 18.5773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_3124_28296",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.884 85.4006) rotate(8.70893) scale(59.8246 18.5773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3124_28296",
    x1: 132.712,
    y1: 198.548,
    x2: 133.701,
    y2: 198.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3124_28296",
    x1: 82.4051,
    y1: 170.521,
    x2: 115.334,
    y2: 146.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3124_28296",
    x1: 83.4423,
    y1: 195.911,
    x2: 116.592,
    y2: 169.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3124_28296",
    x1: 73.395,
    y1: 215.8,
    x2: 145.037,
    y2: 207.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3124_28296",
    x1: 80.8144,
    y1: 160.029,
    x2: 82.3508,
    y2: 160.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3124_28296",
    x1: 87.5305,
    y1: 211.227,
    x2: 122.555,
    y2: 190.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3124_28296",
    x1: 86.29,
    y1: 158.846,
    x2: 118.709,
    y2: 143.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3124_28296",
    x1: 81.3956,
    y1: 182.915,
    x2: 114.543,
    y2: 155.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckRightDown);
export default __webpack_public_path__ + "static/media/truck-right-down.e1f043d294b546907ab15a74e08327ba.svg";
export { ForwardRef as ReactComponent };